// src/pages/LoginPage/LoginPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'; // Import useAuth
import Button from '../../components/Button/Button'; // Import Button
import FormInput from '../../components/FormInput/FormInput'; // Import FormInput
import styles from './LoginPage.module.css';

const LoginPage = () => {
    const [username, setUsername] = useState(''); // CHANGED: from email to username
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [infoMessage, setInfoMessage] = useState('');

    const { login, error: authError, isAuthenticated, loading: authLoading, setError: setAuthError } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Determine where to redirect after login
    // UPDATED: Default to /account/reservations based on MyReservationsPage path
    const from = location.state?.from?.pathname || "/account/reservations";

    useEffect(() => {
        if (location.state?.message) {
            setInfoMessage(location.state.message);
            navigate(location.pathname, { state: {}, replace: true });
        }
    }, [location.state, location.pathname, navigate]);

    useEffect(() => {
        if (!authLoading && isAuthenticated) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, authLoading, navigate, from]);

    // Clear authError from context when username or password changes,
    // or when an info message is set.
    useEffect(() => {
        setAuthError(null);
    }, [username, password, infoMessage, setAuthError]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setInfoMessage('');
        try {
            // CHANGED: Pass an object { username, password } to login
            await login({ username, password });
            // On successful login, the useEffect for isAuthenticated will handle the redirect.
        } catch (error) {
            // Error is set in AuthContext by the login function.
            console.error("Login failed from page:", error.message || error);
        } finally {
            setIsLoading(false);
        }
    };

    if (authLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontFamily: 'var(--font-secondary)',
                color: 'var(--text-dark-heading)',
                backgroundColor: 'var(--bg-light)'
            }}>
                Loading...
            </div>
        );
    }

    if (isAuthenticated) {
        return null;
    }

    return (
        <div className={styles.authPage}>
            <div className={styles.authCard}>
                <div style={{ padding: '10px 0', textAlign: 'center' }}>
                    <Link to="/" className={styles.authLink}>← Back to Home</Link>
                </div>
                <div className={styles.authHeader}>
                    <h2 className={styles.authTitle}>Login</h2>
                    <p className={styles.authSubtitle}>Sign in to access reservations</p>
                </div>

                <div className={styles.authBody}>
                    {infoMessage && !authError && <div className={styles.infoMessage}>{infoMessage}</div>}
                    {authError && <div className={styles.errorMessage}>{authError}</div>}

                    <form onSubmit={handleSubmit}>
                        <FormInput
                            label="Username:" // CHANGED
                            id="username"    // CHANGED
                            name="username"  // CHANGED
                            type="text"      // CHANGED
                            value={username} // CHANGED
                            onChange={(e) => setUsername(e.target.value)} // CHANGED
                            placeholder="Enter your username" // CHANGED
                            required
                            autoComplete="username" // CHANGED
                        />
                        <FormInput
                            label="Password:"
                            id="password"
                            name="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                            autoComplete="current-password"
                        />
                        <Button
                            type="submit"
                            variant="primary"
                            fullWidth
                            disabled={isLoading}
                        >
                            {isLoading ? 'Logging in...' : 'Login'}
                        </Button>
                    </form>
                </div>

                {/* MODIFIED SECTION: Changed link from Register to Forgot Password */}
                <div className={styles.authFooter}>
                    <p className={styles.authFooterText}>
                        Having trouble logging in?{' '}
                        <Link to="/forgot-password" className={styles.authLink}>
                            Forgot Password?
                        </Link>
                    </p>
                </div>
                {/* END MODIFIED SECTION */}
            </div>
        </div>
    );
};

export default LoginPage;